// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconPlus = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M61,8 C61.5522847,8 62,8.44771525 62,9 L62,12 L65,12 C65.5522847,12 66,12.4477153 66,13 C66,13.5522847 65.5522847,14 65,14 L62,14 L62,17 C62,17.5522847 61.5522847,18 61,18 C60.4477153,18 60,17.5522847 60,17 L60,14 L57,14 C56.4477153,14 56,13.5522847 56,13 C56,12.4477153 56.4477153,12 57,12 L60,12 L60,9 C60,8.44771525 60.4477153,8 61,8 Z"
                transform="translate(-56 -8)"
            />
        </svg>
    );
};

export default React.memo(IconPlus);
